<template>
  <div class="sorting">
    <div class="results-actions">
      <div v-if="showFilterToggle" class="action">
        <icon-button
          type="button"
          :icon="searchStore.filtersOpen ? 'filter_alt_off' : 'filter_alt'"
          label="Open Filters"
          classes="-ico-only"
          :icons-outlined="false"
          @click-action="toggleFilters"
        />
        <div
          v-show="searchStore.hasAny"
          class="active-filters"
          aria-label="Has Active Filters"
        ></div>
      </div>
    </div>
    <!-- results + sort vs title only -->
    <div class="sort">
      <span class="result-count">{{ total }} {{ resultLabel }}</span>
      <div v-if="sortable" class="select-style">
        <select
          id="searchFilterSort"
          :value="searchStore.sortSelected"
          aria-label="Sort By"
          @change="triggerSort"
        >
          <option v-for="item in sortOptions" :key="item.value" :value="item.value">
            {{ item.label }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * Search sort, removes "relevance" as an option if there is no keywords
 */
import { computed } from 'vue'
import { useSearchStore } from '@/stores/search'
import IconButton from '@/components/buttons/icon-button.vue'

/** PROPS **/
withDefaults(
  defineProps<{
    showFilterToggle?: boolean
    sortable?: boolean
    total: number
    resultLabel?: string
  }>(),
  {
    showFilterToggle: true,
    sortable: true,
    resultLabel: 'Results',
  },
)

/** STATE **/
const searchStore = useSearchStore()

/** EMITS **/
const emit = defineEmits(['sort-update'])

/** COMPUTED **/
const sortOptions = computed(() => {
  // only show relevance if there are keywords
  if (!searchStore.hasKeywords) {
    return searchStore.sortOptions.filter((option) => option.value !== 'relevance')
  }

  // show all options
  return searchStore.sortOptions
})

/** METHODS **/
function toggleFilters() {
  searchStore.setFiltersOpen(!searchStore.filtersOpen)
}

//because sortSelected is pinia, not using v-model, instead use e.target.value
function triggerSort(e: Event) {
  if (e && e.target instanceof HTMLSelectElement) {
    searchStore.setSortSelected(e.target.value)
    emit('sort-update')
  }
}
</script>
